import { render, staticRenderFns } from "./BookingPassengersAndPayments.vue?vue&type=template&id=5493b27b&scoped=true&"
import script from "./BookingPassengersAndPayments.vue?vue&type=script&lang=ts&"
export * from "./BookingPassengersAndPayments.vue?vue&type=script&lang=ts&"
import style0 from "./BookingPassengersAndPayments.vue?vue&type=style&index=0&id=5493b27b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5493b27b",
  null
  
)

export default component.exports